import React, { Component } from 'react';
import {Form, Input, Select} from "antd";
import {country_select_list} from '../../../requist'
const {Option} = Select;

class DisputeRequestor extends Component{
    constructor(props) {
        super(props);
    }
    render() {
        let list = JSON.parse(window.sessionStorage.getItem('we_country_Texts'))
        let requestor_info = JSON.parse(window.localStorage.getItem('userInfo'))
        return <div className="spaceBox ">
                    <Form.Item
                        label="Dispute Requestor"
                        style={{fontWeight:'bold'}}
                    >
                    </Form.Item>
                    {this.props.type==6 ||
                    this.props.type==7 ||
                    this.props.type==8 ||
                    this.props.type==10 ||
                    this.props.type==11?'':
                        <Form.Item
                            label="Requestor"
                            name={'requesterId'}
                            rules={[{ required: true }]}
                            initialValue={requestor_info.requestorID}
                        >
                            <Input maxLength={50} />
                        </Form.Item>
                    }
                    {
                        this.props.type===1 || this.props.type===3 || this.props.type===4 || this.props.type===7 || this.props.type===8 || this.props.type===11?
                            <Form.Item
                                label="Phone Number"
                                name={'requesterPhoneNo'}
                                rules={[{ required: false}]}
                                initialValue={requestor_info.requestorPhoneNo}
                            >
                                <Input maxLength={30} />
                            </Form.Item>:''
                    }
                    <Form.Item
                        label="Email Address"
                        name={'requesterEmail'}
                        rules={[{ required: true }]}
                        initialValue={requestor_info.requestorEmail}
                    >
                        <Input maxLength={200} />
                    </Form.Item>
                    <Form.Item
                        label="Country"
                        name={'requesterCountry'}
                        rules={[{ required: true }]}
                    >
                        <Select placeholder='Please select'>
                            {
                                list[0].sort((a, b) => {
                                    return a.countryText.charCodeAt(0)-b.countryText.charCodeAt(0)
                                }).map((item)=>{
                                    return <Option value={item.country} >{item.countryText}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>

                </div>
    }
}

export default DisputeRequestor;